import { X } from "lucide-react";
import ProductCard from "@/components/ProductCard";

export default function SubButtonPopup({ parentProduct, subButtons, onAddToCart, onClose, displaySettings, allProducts }) {
  // Build product lookup from pre-loaded products (no API call needed)
  const products = {};
  if (allProducts) {
    const ids = new Set(subButtons.filter(sb => sb.product_id).map(sb => sb.product_id));
    allProducts.forEach(p => { if (ids.has(p.id)) products[p.id] = p; });
  }

  const handleClick = (sb) => {
    if (sb.product_id) {
      const product = products[sb.product_id];
      if (product) { onAddToCart(product); onClose(); }
    } else {
      onClose();
    }
  };

  // Only keep sub-buttons that have a product or label assigned — skip empty slots
  const activeButtons = subButtons
    .filter(sb => sb.product_id || sb.label)
    .sort((a, b) => a.position - b.position);

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-2xl p-5 w-[812px] max-w-[95vw]" onClick={(e) => e.stopPropagation()} data-testid="sub-button-popup">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-bold text-zinc-900" data-testid="sub-button-popup-title">{parentProduct?.product_name || parentProduct?.name || "Select Item"}</h3>
          <button onClick={onClose} className="text-zinc-400 hover:text-zinc-600" aria-label="Close sub-button popup" data-testid="sub-button-popup-close"><X className="w-6 h-6" /></button>
        </div>
        <div className="grid grid-cols-4 gap-3">
          {activeButtons.map((sb, i) => {
            const product = sb.product_id ? products[sb.product_id] : null;
            if (product) {
              const subDisplaySettings = displaySettings ? { ...displaySettings, show_images: true } : { show_images: true };
              return (
                <div key={sb.product_id || `sb-${sb.position}`} className="aspect-square" data-testid={`sub-btn-${i}`}>
                  <ProductCard
                    product={product}
                    onAdd={() => handleClick(sb)}
                    displaySettings={subDisplaySettings}
                    displayName={sb.label || null}
                    buttonImage={sb.image_url || null}
                    buttonStyleOverride={sb.card_style || null}
                    buttonBorderOverride={sb.border_color || sb.color || null}
                  />
                </div>
              );
            }
            // Label-only button (no product)
            return (
              <button
                key={sb.label || `sb-${sb.position}`}
                onClick={() => handleClick(sb)}
                className="aspect-square rounded-lg border-2 border-zinc-200 hover:border-blue-400 hover:shadow-lg active:scale-95 transition-all flex flex-col items-center justify-center p-2 cursor-pointer bg-zinc-50"
                data-testid={`sub-btn-${i}`}
              >
                {sb.image_url && <img src={sb.image_url} alt="" className="w-3/5 h-3/5 object-contain mb-1" data-testid={`sub-btn-${i}-image`} onError={(e) => { e.target.style.display = "none"; }} />}
                <span className="text-sm font-bold text-zinc-800 text-center leading-tight line-clamp-2">{sb.label || "..."}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
